var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container has-text-centered",staticStyle:{"margin-top":"42px"}},[_c('h1',{staticClass:"title"},[_vm._v("Order was successfully created.")]),_c('b-button',{staticClass:"has-text-centered",attrs:{"type":"is-primary"},on:{"click":function($event){return _vm.$router.push('/orders')}}},[_vm._v("List of\n    orders\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }